import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import '../../styles/textStyle.css';
import '../spin-buttons/SpinButton.css';
import '../date-time-picker/DateTimePicker.css';
import './DateTimeRangePicker.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var dateTimeInput = '_1vlwkc26-3-8-0';
export var dateTimeRange = _7a468({defaultClassName:'_1vlwkc20-3-8-0',variantClassNames:{showError:{true:'_1vlwkc21-3-8-0'},disabled:{true:'_1vlwkc22-3-8-0'},readOnly:{true:'_1vlwkc23-3-8-0'}},defaultVariants:{},compoundVariants:[[{showError:true,readOnly:true},'_1vlwkc24-3-8-0']]});
export var scrollContainer = '_1vlwkc25-3-8-0';
export var timeframeSeparator = '_1vlwkc27-3-8-0';